export class Ville {

    vil_id: string;
    vil_pay_id: string;
    vil_libelle: string;
    vil_custom: boolean;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.vil_id         = data['vil_id'] ? data['vil_id'] : null;
        this.vil_pay_id     = data['vil_pay_id'] ? data['vil_pay_id'] : null;
        this.vil_libelle    = data['vil_libelle'] ? data['vil_libelle'] : null;
        this.vil_custom     = data['vil_custom'] && data['vil_custom'] === '1';
    }

}
